export const URL_CAMPAIGN_PRODUCTS_ROUTE = 'campaigns';
